import React from "react";

export const RegContext = React.createContext();
export const PersonListPageContext = React.createContext();
export const RuleContext = React.createContext();
export const FormContext = React.createContext();
export const RegGroupContext = React.createContext();
